import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Play } from "lucide-react";

const CATEGORIES = ["All", "Reels", "Social Media Creatives", "Website Projects", "Brand Campaigns", "Performance Creatives"];

const WORK = [
  { cat: "Reels", title: "Lifestyle Reel Series", client: "Atelier North", description: "10-part Instagram reel series for premium lifestyle brand.", platform: "Instagram", result: "+312% engagement", img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsJTIwZGF0YSUyMGRhc2hib2FyZCUyMGFuYWx5dGljcyUyMGRhcmt8ZW58MHx8fHwxNzgwODU2MTg2fDA&ixlib=rb-4.1.0&q=85" },
  { cat: "Reels", title: "Skincare Hero Reel", client: "Vanta Co.", description: "Hook-led reel for D2C skincare launch.", platform: "Instagram & TikTok", result: "1.2M organic reach", img: "https://images.unsplash.com/photo-1642945538257-d1e69abfb085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeSUyMGRhcmslMjBnb2xkJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MDg1NjE4Nnww&ixlib=rb-4.1.0&q=85" },
  { cat: "Reels", title: "Boutique Hotel Reels", client: "Northwood", description: "Quarterly reel package for premium hotel chain.", platform: "Instagram", result: "32% direct booking lift", img: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjB0ZXh0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODA4NTYxODZ8MA&ixlib=rb-4.1.0&q=85" },
  { cat: "Social Media Creatives", title: "Editorial Carousel Series", client: "Maison 27", description: "Monthly editorial carousels for a fashion atelier.", platform: "Instagram", result: "+58% saves", img: "https://images.unsplash.com/photo-1698500278205-bf650c97a1f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjB0ZXh0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODA4NTYxODZ8MA&ixlib=rb-4.1.0&q=85" },
  { cat: "Website Projects", title: "Performance Site Build", client: "Marq Studio", description: "Premium WordPress build with conversion-focused architecture.", platform: "Web", result: "3.4× conversion uplift", img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsJTIwZGF0YSUyMGRhc2hib2FyZCUyMGFuYWx5dGljcyUyMGRhcmt8ZW58MHx8fHwxNzgwODU2MTg2fDA&ixlib=rb-4.1.0&q=85" },
  { cat: "Website Projects", title: "Landing Page Suite", client: "Obsidian", description: "Multi-variant landing pages for performance campaigns.", platform: "Web", result: "0.62 CPL across Meta", img: "https://images.unsplash.com/photo-1642945538257-d1e69abfb085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeSUyMGRhcmslMjBnb2xkJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MDg1NjE4Nnww&ixlib=rb-4.1.0&q=85" },
  { cat: "Brand Campaigns", title: "Launch Campaign", client: "Rivo Brand", description: "Integrated brand launch with film, social and PR.", platform: "Omni-channel", result: "Featured in Vogue India", img: "https://images.unsplash.com/photo-1761437855740-c894da924d79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjB0ZXh0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODA4NTYxODZ8MA&ixlib=rb-4.1.0&q=85" },
  { cat: "Brand Campaigns", title: "Festive Brand Push", client: "Kairos", description: "Festive omnichannel campaign with high-impact visuals.", platform: "Meta + Print", result: "+42% topline lift", img: "https://images.unsplash.com/photo-1698500278205-bf650c97a1f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdlb21ldHJpYyUyMGdvbGQlMjB0ZXh0dXJlJTIwZGFya3xlbnwwfHx8fDE3ODA4NTYxODZ8MA&ixlib=rb-4.1.0&q=85" },
  { cat: "Performance Creatives", title: "FinTech Performance Pack", client: "Arcane Labs", description: "Creative testing pack with 18 variants for Meta Ads.", platform: "Meta Ads", result: "0.58 CPC", img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBtaW5pbWFsJTIwZGF0YSUyMGRhc2hib2FyZCUyMGFuYWx5dGljcyUyMGRhcmt8ZW58MHx8fHwxNzgwODU2MTg2fDA&ixlib=rb-4.1.0&q=85" },
  { cat: "Performance Creatives", title: "Wellness Lead Gen", client: "Monolith", description: "Cold-to-warm funnel with custom creatives & retargeting.", platform: "Meta + Google", result: "4.2× ROAS", img: "https://images.unsplash.com/photo-1642945538257-d1e69abfb085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGx1eHVyeSUyMGRhcmslMjBnb2xkJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MDg1NjE4Nnww&ixlib=rb-4.1.0&q=85" },
];

export default function Work() {
  const [active, setActive] = useState("All");
  useEffect(() => { document.title = "Work — The Indian Marketing"; }, []);

  const filtered = useMemo(
    () => (active === "All" ? WORK : WORK.filter((w) => w.cat === active)),
    [active]
  );

  return (
    <div data-testid="work-page" className="bg-[#2E2E31] text-white">
      <section className="pt-40 pb-16 md:pt-48 md:pb-20 relative overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="font-outfit text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Portfolio</span>
          </div>
          <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl text-white tracking-tight leading-[1.05] max-w-4xl">
            Our <em className="text-[#D4AF37] font-normal">Creative</em> Work.
          </h1>
          <p className="font-outfit text-lg md:text-xl text-[#D9D9D9] mt-10 max-w-3xl leading-relaxed">
            A glimpse into selected reels, social creatives, website builds, brand campaigns and performance creatives we've crafted for our partners.
          </p>
        </div>
      </section>

      {/* Filter */}
      <section className="border-y border-white/10 sticky top-20 bg-[#2E2E31]/90 backdrop-blur-xl z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex gap-2 overflow-x-auto">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              data-testid={`work-filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
              className={`whitespace-nowrap font-outfit text-xs uppercase tracking-[0.2em] px-4 py-2 border transition-colors ${
                active === c
                  ? "bg-[#D4AF37] text-black border-[#D4AF37]"
                  : "text-[#D9D9D9] border-white/15 hover:border-[#D4AF37]/60 hover:text-white"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      {/* Grid */}
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((w, i) => (
              <motion.article
                key={`${w.client}-${i}`}
                data-testid={`work-card-${i}`}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }}
                className="group relative overflow-hidden zoom-on-hover cursor-pointer"
              >
                <div className="aspect-[3/4] relative overflow-hidden">
                  <img src={w.img} alt={w.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-[#111111]/40 to-transparent" />
                  {w.cat === "Reels" && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="play-icon-circle">
                        <Play size={26} className="text-black ml-1" fill="currentColor" />
                      </div>
                    </div>
                  )}
                  <div className="absolute top-5 left-5 bg-[#111111]/80 backdrop-blur-md text-[#D4AF37] font-outfit text-[10px] uppercase tracking-[0.25em] px-3 py-1.5 border border-[#D4AF37]/30">
                    {w.cat}
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="font-outfit text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] mb-2">{w.client}</div>
                  <h3 className="font-playfair text-2xl text-white tracking-tight mb-2">{w.title}</h3>
                  <p className="font-outfit text-sm text-[#D9D9D9]/90 mb-3">{w.description}</p>
                  <div className="flex justify-between text-[11px] font-outfit uppercase tracking-[0.18em] text-[#D9D9D9]/70 border-t border-white/10 pt-3">
                    <span>{w.platform}</span>
                    <span className="text-[#D4AF37]">{w.result}</span>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#111111]">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-playfair text-4xl md:text-5xl text-white tracking-tight leading-tight">
            Like what you see?
          </h2>
          <p className="font-outfit text-lg text-[#D9D9D9] mt-6 max-w-2xl mx-auto">
            Let's craft work like this for your brand. Tell us what you're building — we'll bring the strategy and the craft.
          </p>
          <Link
            to="/contact"
            data-testid="work-cta-contact"
            className="inline-flex items-center gap-3 mt-10 bg-[#D4AF37] text-black font-outfit font-medium px-10 py-5 uppercase tracking-[0.2em] text-sm hover:bg-[#F0C84B] transition-colors"
          >
            Start a Project <ArrowUpRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
